(function () {
'use strict';

angular.module('hyresgastApp').factory('RentFiles', function ($resource) {
  return $resource(
    '/api/rent-files',
    { blobId: '@blobId' },
    {
      getErrorReport: {
        url: '/api/rent-files/:blobId/validate-excel',
        method: 'GET',
        responseType: 'arraybuffer',
        transformResponse: (data, headers) => ({ data, headers })
      },
    }
  );
});

})();